module.exports = __webpack_public_path__ + "assets/img/00078.3362d9d7.png";